<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<div *ngIf="displayReport">
    <dx-data-grid
        id="bdsReportGrid"
        bds-grid
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        [allowColumnResizing]="false"
        dataRowTemplate="dataRowTemplateName"
    >
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>
        <dxi-column dataField="fleet_id" caption="Fleet ID"></dxi-column>
        <dxi-column dataField="business_group" caption="Business Group"></dxi-column>
        <dxi-column caption="*  At Origin  *">
            <dxi-column
                dataField="at_origin_empty"
                caption="Empty"
                dataType="number"
                alignment="left"
            ></dxi-column>
            <dxi-column
                dataField="at_origin_loaded"
                caption="Loaded"
                dataType="number"
                alignment="left"
            ></dxi-column>
        </dxi-column>
        <dxi-column
            dataField="to_consignee"
            caption="To Consignee"
            dataType="number"
            alignment="left"
        ></dxi-column>
        <dxi-column
            dataField="to_shop"
            caption="To Shop"
            dataType="number"
            alignment="left"
        ></dxi-column>
        <dxi-column
            dataField="at_consignee"
            caption="At Consignee"
            dataType="number"
            alignment="left"
        ></dxi-column>
        <dxi-column
            dataField="at_shop"
            caption="At Shop"
            dataType="number"
            alignment="left"
        ></dxi-column>
        <dxi-column
            dataField="to_origin"
            caption="To Origin"
            dataType="number"
            alignment="left"
        ></dxi-column>
        <dxi-column
            dataField="no_bills"
            caption="No. Bill"
            dataType="number"
            alignment="left"
        ></dxi-column>
        <dxi-column
            dataField="no_trips"
            caption="No. Trips"
            dataType="number"
            alignment="left"
        ></dxi-column>
        <dxi-column
            dataField="total_cars"
            caption="Total"
            dataType="number"
            alignment="left"
        ></dxi-column>
        <dxi-column
            dataField="percent_util"
            caption="% Utilization"
            dataType="number"
            alignment="left"
        ></dxi-column>
        <ng-container *dxTemplate="let item of 'dataRowTemplateName'">
            <tr>
                <td>{{ item.data.fleet_id }}</td>
                <td>{{ item.data.business_group }}</td>
                <td>{{ item.data.at_origin_empty }}</td>
                <td>{{ item.data.at_origin_loaded }}</td>
                <td>{{ item.data.to_consignee }}</td>
                <td>{{ item.data.to_shop }}</td>
                <td>{{ item.data.at_consignee }}</td>
                <td>{{ item.data.at_shop }}</td>
                <td>{{ item.data.to_origin }}</td>
                <td>{{ item.data.no_bills }}</td>
                <td>{{ item.data.no_trips }}</td>
                <td>{{ item.data.total_cars }}</td>
                <td>{{ item.data.percent_util }}</td>
            </tr>
            <tr>
                <td colspan="2">&nbsp;</td>
                <td>{{ item.data.at_origin_empty_percent }} %</td>
                <td>{{ item.data.at_origin_loaded_percent }} %</td>
                <td>{{ item.data.to_consignee_percent }} %</td>
                <td>{{ item.data.to_shop_percent }} %</td>
                <td>{{ item.data.at_consignee_percent }} %</td>
                <td>{{ item.data.at_shop_percent }} %</td>
                <td>{{ item.data.to_origin_percent }} %</td>
                <td>{{ item.data.no_bills_percent }} %</td>
                <td>{{ item.data.no_trips_percent }} %</td>
                <td colspan="2">&nbsp;</td>
            </tr>
        </ng-container>
        <dxo-summary>
            <dxi-total-item
                column="fleet_id"
                displayFormat="Total:"
                alignment="left"
            ></dxi-total-item>
            <dxi-total-item
                column="fleet_id"
                displayFormat="Avg:"
                alignment="left"
            ></dxi-total-item>
            <dxi-total-item
                column="fleet_id"
                displayFormat="Min:"
                alignment="left"
            ></dxi-total-item>
            <dxi-total-item
                column="fleet_id"
                displayFormat="Max:"
                alignment="left"
            ></dxi-total-item>

            <dxi-total-item
                column="at_origin_empty"
                summaryType="sum"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="at_origin_empty"
                summaryType="avg"
                displayFormat="{0}"
                valueFormat="#0.##"
            ></dxi-total-item>
            <dxi-total-item
                column="at_origin_empty"
                summaryType="min"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="at_origin_empty"
                summaryType="max"
                displayFormat="{0}"
            ></dxi-total-item>

            <dxi-total-item
                column="at_origin_loaded"
                summaryType="sum"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="at_origin_loaded"
                summaryType="avg"
                displayFormat="{0}"
                valueFormat="#0.##"
            ></dxi-total-item>
            <dxi-total-item
                column="at_origin_loaded"
                summaryType="min"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="at_origin_loaded"
                summaryType="max"
                displayFormat="{0}"
            ></dxi-total-item>

            <dxi-total-item
                column="to_consignee"
                summaryType="sum"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="to_consignee"
                summaryType="avg"
                displayFormat="{0}"
                valueFormat="#0.##"
            ></dxi-total-item>
            <dxi-total-item
                column="to_consignee"
                summaryType="min"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="to_consignee"
                summaryType="max"
                displayFormat="{0}"
            ></dxi-total-item>

            <dxi-total-item column="to_shop" summaryType="sum" displayFormat="{0}"></dxi-total-item>
            <dxi-total-item
                column="to_shop"
                summaryType="avg"
                displayFormat="{0}"
                valueFormat="#0.##"
            ></dxi-total-item>
            <dxi-total-item column="to_shop" summaryType="min" displayFormat="{0}"></dxi-total-item>
            <dxi-total-item column="to_shop" summaryType="max" displayFormat="{0}"></dxi-total-item>

            <dxi-total-item
                column="at_consignee"
                summaryType="sum"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="at_consignee"
                summaryType="avg"
                displayFormat="{0}"
                valueFormat="#0.##"
            ></dxi-total-item>
            <dxi-total-item
                column="at_consignee"
                summaryType="min"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="at_consignee"
                summaryType="max"
                displayFormat="{0}"
            ></dxi-total-item>

            <dxi-total-item column="at_shop" summaryType="sum" displayFormat="{0}"></dxi-total-item>
            <dxi-total-item
                column="at_shop"
                summaryType="avg"
                displayFormat="{0}"
                valueFormat="#0.##"
            ></dxi-total-item>
            <dxi-total-item column="at_shop" summaryType="min" displayFormat="{0}"></dxi-total-item>
            <dxi-total-item column="at_shop" summaryType="max" displayFormat="{0}"></dxi-total-item>

            <dxi-total-item
                column="to_origin"
                summaryType="sum"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="to_origin"
                summaryType="avg"
                displayFormat="{0}"
                valueFormat="#0.##"
            ></dxi-total-item>
            <dxi-total-item
                column="to_origin"
                summaryType="min"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="to_origin"
                summaryType="max"
                displayFormat="{0}"
            ></dxi-total-item>

            <dxi-total-item
                column="no_bills"
                summaryType="sum"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="no_bills"
                summaryType="avg"
                displayFormat="{0}"
                valueFormat="#0.##"
            ></dxi-total-item>
            <dxi-total-item
                column="no_bills"
                summaryType="min"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="no_bills"
                summaryType="max"
                displayFormat="{0}"
            ></dxi-total-item>

            <dxi-total-item
                column="no_trips"
                summaryType="sum"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="no_trips"
                summaryType="avg"
                displayFormat="{0}"
                valueFormat="#0.##"
            ></dxi-total-item>
            <dxi-total-item
                column="no_trips"
                summaryType="min"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="no_trips"
                summaryType="max"
                displayFormat="{0}"
            ></dxi-total-item>

            <dxi-total-item
                column="total_cars"
                summaryType="sum"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="total_cars"
                summaryType="avg"
                displayFormat="{0}"
                valueFormat="#0.##"
            ></dxi-total-item>
            <dxi-total-item
                column="total_cars"
                summaryType="min"
                displayFormat="{0}"
            ></dxi-total-item>
            <dxi-total-item
                column="total_cars"
                summaryType="max"
                displayFormat="{0}"
            ></dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
</div>
